import React from 'react';
import { IEscrowFileCompleteData } from '../../../../../types/order/escrow/IEscrowFileCompleteData';
import { useFormikContext } from 'formik';
import { Button } from '../../../../../ui-toolkit';
import { isEmpty } from 'lodash';

export const SpaEscrowSubmitButton: React.FC<{
  onFormSubmit: (formData: IEscrowFileCompleteData, touched: any) => Promise<void>;
  disabled?: boolean;
}> = ({ onFormSubmit, disabled = false }) => {
  const formik = useFormikContext<IEscrowFileCompleteData>();
  const { values, touched, validateForm, handleSubmit } = formik;
  return (
    <Button
      intent={'primary'}
      disabled={disabled}
      onClick={() => {
        validateForm(values)
          .then((errors) => {
            if (isEmpty(errors)) {
              return onFormSubmit(values, touched);
            }
            throw Error('invalid escrow form');
          })
          .catch(() => handleSubmit());
      }}
    >
      Update Escrow File
    </Button>
  );
};
